import React, {useEffect, useState} from "react";
import keycloak from "../utils/keycloak";
import {useSetRecoilState} from "recoil";
import {authState} from "../states/auth-state/auth-atoms";
import {ThreeDots} from "react-loader-spinner";
import {Providers} from "../providers";

interface KeycloakProviderProps {
  children: React.ReactNode;
}

const KeycloakProvider: React.FC<KeycloakProviderProps> = ({ children }) => {
  const [authenticated, setAuthenticated] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const setAuthState = useSetRecoilState(authState);

  useEffect(() => {
    setPostData();
    const initKeycloak = async () => {
      try {
        await keycloak.init({ onLoad: "check-sso" })
        if (keycloak.authenticated) {
          setAuthenticated(true);
          localStorage.setItem('token', keycloak?.token || '');
          localStorage.setItem('name', keycloak?.tokenParsed?.name || '');
          setAuthState({
            token: keycloak.token || null,
            refreshToken: keycloak.refreshToken || null,
            tokenParsed: keycloak.tokenParsed || null,
          });
        } else {
          keycloak.login({idpHint: 'okta'});
        }
      } catch (error) {
        console.error("Keycloak initialization failed:", error);
      } finally {
        setLoading(false);
      }
    };

    initKeycloak();
  }, [setAuthState]);

  const setPostData = () => {
    const params = new URLSearchParams(window.location.search);
    localStorage.setItem('url', window.location.href)
    localStorage.setItem('carrierPostData', params?.get('carrierPostData') || '');
    localStorage.setItem('authorizationToken', params?.get('authorizationToken') || '');
    localStorage.setItem('eid', params?.get('eid') || '');
    localStorage.setItem('iccids', params?.get('iccids') || '');
    localStorage.setItem('displayName', decodeURIComponent(params?.get('displayName') || '')  || '');
    localStorage.setItem('deviceImei', params?.get('deviceImei') || '');
    localStorage.setItem('deviceMeid', params?.get('deviceMeid') || '');
    localStorage.setItem('deviceType', params?.get('deviceType') || '');
    localStorage.setItem('primaryDeviceIccid', params?.get('primaryDeviceIccid') || '');
  };

  if (loading) {
    return (
        <ThreeDots
            visible={true}
            height="80"
            width="80"
            color="#FFD200"
            radius="9"
            ariaLabel="three-dots-loading"
            wrapperClass="full-layout"
        />
    );
  }

  if (!authenticated) {
    return (
        <ThreeDots
            visible={true}
            height="80"
            width="80"
            color="#FFD200"
            radius="9"
            ariaLabel="three-dots-loading"
            wrapperClass="full-layout"
        />
    );
  }

  return <Providers>{children}</Providers>;
};

export default KeycloakProvider;